import * as React from 'react'
import ReadMoreIcon from '@mui/icons-material/ReadMore'
import { DialogContentText, IconButton } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import { GridColDef } from '@mui/x-data-grid'
import AbstractAuditLogDataGrid from 'common/AbstractAuditLogDataGrid'
import CrossDialogBtn from 'common/Button/CrossDialogBtn'
import TextColorFontHeader from 'common/Typography/TextColorFontHeader'
import useModal from 'hooks/useModal'

const columns: GridColDef[] = [
  { field: 'lastname', headerName: 'Passenger Last Name', width: 100 },
  { field: 'firstname', headerName: 'Passenger First Name', width: 100 }
]

export default function MorePassengerDialog({ morePassengersDetails }: Props) {
  const {
    openModal: openMorePassengerModal,
    closeModal: closeMorePassengerModal,
    isShowing: isMorePassengerModalOpen
  } = useModal()

  const handleSeeMorePassengersClick = () => {
    openMorePassengerModal()
  }

  return (
    <>
      <IconButton onClick={handleSeeMorePassengersClick}>
        <ReadMoreIcon sx={{ fontSize: '24px' }} />
      </IconButton>
      <Dialog
        open={isMorePassengerModalOpen}
        onClose={closeMorePassengerModal}
        fullWidth={true}
        maxWidth='md'
      >
        <DialogContentText
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <TextColorFontHeader sx={{ px: 2, pt: 2 }}>
            Additional Passengers Added ({morePassengersDetails.length})
          </TextColorFontHeader>
          <CrossDialogBtn
            sx={{ pr: 4 }}
            dialogClose={closeMorePassengerModal}
          />
        </DialogContentText>
        <DialogContent>
          <AbstractAuditLogDataGrid
            columns={columns}
            rows={morePassengersDetails}
            getRowId={(row) =>
              morePassengersDetails.indexOf(row) + 'smartDelay'
            }
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
interface Props {
  morePassengersDetails: {
    firstname?: string
    lastname?: string
  }[]
}
